import firebase from 'firebase'

const firebaseApp = firebase.initializeApp(
    {
        apiKey: "AIzaSyCv1HLka2ssJCgnPJvBvkW3ms9js15lTus",
        authDomain: "cifras-bolsillo.firebaseapp.com",
        databaseURL: "https://cifras-bolsillo.firebaseio.com",
        projectId: "cifras-bolsillo",
        storageBucket: "cifras-bolsillo.appspot.com",
        messagingSenderId: "185589607218",
        appId: "1:185589607218:web:2bfdbe7f7a4f90575b052b",
        measurementId: "G-RJYY65TK19"
    }

)

const db = firebaseApp.firestore()


export { db }
